(() => {
  const core = window.FerretiBA26;
  if (!core || window.ferretiBA26CartReady) return;
  window.ferretiBA26CartReady = true;
  const originalFetch = window.fetch.bind(window);
  const root = window.Shopify?.routes?.root || '/';
  const end = Date.parse('2026-12-01T07:59:00Z');
  let pending = false;
  let running = null;
  const snapshot = async () => {
    const response = await originalFetch(`${root}cart?section_id=ferreti-ba26-cart-state`, { cache: 'no-store' });
    if (!response.ok) throw new Error('No se pudo consultar el carrito');
    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    return JSON.parse(html.querySelector('[data-ba26-cart-state]').textContent);
  };
  const mutate = async (endpoint, payload) => {
    const response = await originalFetch(`${root}cart/${endpoint}.js`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
    });
    if (!response.ok) throw new Error('No se pudo actualizar el regalo');
    return response.json();
  };
  const refresh = async () => {
    const response = await originalFetch(`${root}?sections=cart-drawer,cart-icon-bubble,main-cart-items,main-cart-footer`, { cache: 'no-store' });
    if (!response.ok) return;
    const sections = await response.json();
    const drawer = document.querySelector('cart-drawer');
    if (drawer && sections['cart-drawer']) {
      // Update rendered sections without opening the drawer or interrupting registration.
      const html = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      const inner = drawer.querySelector('#CartDrawer');
      const fresh = html.querySelector('#CartDrawer');
      if (inner && fresh) inner.innerHTML = fresh.innerHTML;
      drawer.classList.toggle('is-empty', !html.querySelector('cart-drawer-items .cart-item'));
      drawer.querySelector('#CartDrawer-Overlay')?.addEventListener('click', drawer.close.bind(drawer));
      drawer.setupRecommendations?.();
    }
    ['cart-icon-bubble', 'main-cart-items', 'main-cart-footer'].forEach(id => {
      const target = document.getElementById(id) || document.getElementById(`shopify-section-${id}`);
      if (!target || !sections[id]) return;
      const html = new DOMParser().parseFromString(sections[id], 'text/html');
      const replacement = html.getElementById(id) || html.querySelector('.shopify-section');
      if (replacement) target.innerHTML = replacement.innerHTML;
    });
    document.dispatchEvent(new CustomEvent('shopify:section:load'));
  };
  const reconcile = () => {
    pending = true;
    if (running) return running;
    running = (async () => {
      let success = true;
      try {
        while (pending) {
          pending = false;
          const state = await snapshot();
          if (Date.now() >= end) state.lines.forEach(line => { line.eligible = false; });
          const plan = core.giftPlan(state.lines);
          let changed = false;
          if (Object.keys(plan.updates).length) {
            await mutate('update', { updates: plan.updates });
            changed = true;
          }
          if (plan.add && state.giftAvailable) {
            await mutate('add', { items: [{ id: 49361011966225, quantity: 1,
              properties: { _ba26_gift: '1', 'Regalo': 'Black Alucín · El Gallo Negro' } }] });
            changed = true;
          }
          if (changed) await refresh();
        }
      } catch (error) {
        success = false;
        console.warn('Black Alucín: no se pudo sincronizar el regalo.', error.message);
        document.dispatchEvent(new CustomEvent('ba26:gift-error'));
      } finally { running = null; }
      return success;
    })();
    return running;
  };
  window.fetch = async (...args) => {
    const response = await originalFetch(...args);
    const url = String(args[0]?.url || args[0]);
    if (response.ok && /\/cart\/(add|change|update)(\.js)?(?:\?|$)/.test(url)) {
      // Consumers render the initial response first; the follow-up uses real Shopify totals.
      window.setTimeout(reconcile, 200);
    }
    return response;
  };
  core.reconcile = reconcile;
  document.addEventListener('DOMContentLoaded', reconcile, { once: true });
  document.addEventListener('click', async event => {
    const checkout = event.target.closest('[name="checkout"], a[href$="/checkout"]');
    if (!checkout || checkout.dataset.ba26Ready === '1') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    checkout.disabled = true;
    const confirmed = await reconcile();
    checkout.disabled = false;
    if (!confirmed) {
      const error = document.querySelector('[data-ba26-cart-error]');
      if (error) {
        error.hidden = false;
        error.textContent = 'No pudimos confirmar el regalo de tu pedido. Intenta de nuevo antes de continuar.';
      }
      return;
    }
    checkout.dataset.ba26Ready = '1';
    window.location.assign(`${root}checkout`);
  }, true);
})();
